module.exports = __webpack_public_path__ + "static/SuisseIntl-Light-d57f8e36599034b62d6393b01aba2a50.woff2";